import { object } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

const useYupForm = ({ shape, defaultValues, mode = 'onSubmit' }) => {
  const FormSchema = object().shape(shape);

  const methods = useForm({
    resolver: yupResolver(FormSchema),
    defaultValues,
    mode,
  });

  return { methods, ...methods };
};

export default useYupForm;
